

















































































































/* Created- 31 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import { SectionModel, ISectionModel } from "../../Generated/ParticaAPI";
import { ParticaEvent, eParticaAction, getActionName } from "../../Models/ParticaEvent";
import { ParticaItem, ParticaSubItem, ParticaDropEvent, eParticaDragType } from "../../Models/ParticaItem";
import ParticaUIBase from "../Base/ParticaUIBase.vue";
import { ButtonConfig } from "../../Models/Buttons";

@Component(
	{
		name: "ManageArticles",
		components: {
			ParticaCard
		}
	})
export default class ManageArticles extends ParticaUIBase {
	@Prop() private data: ParticaItem[];
	@Prop() private title: string;
	@Prop() private parenttype: string;
	@Prop() private subtitle: string;

	private buttons: ButtonConfig[] = [
		{ label: "Preview", action: eParticaAction.ARTICLE_PREVIEW, icon: "visibility" } as ButtonConfig,
		{ label: "Edit", action: eParticaAction.ARTICLE_EDIT, icon: "edit" } as ButtonConfig,
		{ label: "Delete", action: eParticaAction.ARTICLE_DELETE_REQUEST, icon: "delete" } as ButtonConfig,
	];

	private addArticle(folder: ParticaItem) {
		const pe: ParticaEvent = { action: eParticaAction.ADD_WRITTEN_ARTICLE, item: folder } as ParticaEvent;
		this.$emit("partica-event", pe);
	}

	private async click(button: ButtonConfig, item: ParticaSubItem, e: any) {
		const pe: ParticaEvent = { action: button.action, item, sourceEvent: e } as ParticaEvent;
		this.$emit("partica-event", pe);
	}

	private dragover(e: any) {
		e.dataTransfer.dropEffect = "move";
	}
	private dragstartchild(item: ParticaSubItem, e: any) {
		const dragdata: ParticaDropEvent = { dragtype: eParticaDragType.one, source: item } as ParticaDropEvent;
		e.dataTransfer.setData("application/json", JSON.stringify(dragdata));
	}
	private dragstartparent(item: ParticaItem, e: any) {
		const dragdata: ParticaDropEvent = { dragtype: eParticaDragType.many, source: item } as ParticaDropEvent;
		e.dataTransfer.setData("application/json", JSON.stringify(dragdata));
	}
	private drop(destination: ParticaItem, e: any) {
		const dropped: ParticaDropEvent = JSON.parse(e.dataTransfer.getData("application/json")) as ParticaDropEvent;
		dropped.destination = destination;
		const pevent: ParticaEvent = { action: eParticaAction.DRAG_MOVE_REQUEST, item: dropped } as ParticaEvent;
		this.$emit("partica-event", pevent);
	}
	private rightClick(article: ParticaSubItem) {
		this.$emit("partica-event", { action: eParticaAction.RIGHT_MOUSE_CLICK, item: article } as ParticaEvent);
	}
}
